import { Modal, Text } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { useOrganizationChatAiPageStore } from '@/stores/local/pages/OrganizationChatAiPageStore';

import FeedbackContent from './FeedbackContent';
import SuccessContent from './SuccessContent';

const FeedbackModal: React.FC = () => {
  const {
    answerRatingStore: { feedbackModal, canShowSuccessModal, closeFeedbackModal },
  } = useOrganizationChatAiPageStore();

  return (
    <Modal
      centered
      title={<Text fw="600">Что пошло не так?</Text>}
      opened={feedbackModal.isOpen}
      onClose={closeFeedbackModal}
    >
      {!canShowSuccessModal ? <FeedbackContent /> : <SuccessContent />}
    </Modal>
  );
};

export default observer(FeedbackModal);
